// src/main.js
import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // 导入路由

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

// 引入axios库，用于通信
import axios from "axios";

import NProgress from "nprogress";
import "nprogress/nprogress.css";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// 引入Element UI等依赖...
axios.interceptors.request.use((config) => {
  // 展示进度条
  NProgress.start();
  config.headers.Authorization = window.sessionStorage.getItem("token");
  console.log(window.sessionStorage.getItem("token"));
  return config;
});
// 在response拦截器中，隐藏进度条
axios.interceptors.response.use((config) => {
  NProgress.done();
  return config;
});
// 每一个this组件都可以通过this.$http来发起请求
Vue.prototype.$http = axios;
/**
 * 阻止启动生产消息
 * 开发环境下，Vue 会提供很多警告来帮你对付常见的错误与陷阱。
 * 而在生产环境下，这些警告语句却没有用，反而会增加应用的体积。
 * 此外，有些警告检查还有一些小的运行时开销，这在生产环境模式下
 * 是可以避免的。(摘于官网说明) 大概意思应该就是，消息提示的环境配置，
 * 设置为开发环境或者生产环境
 */
Vue.config.productionTip = false;
new Vue({
  router, // 注入路由
  render: (h) => h(App),
}).$mount("#app");
